import { useFonts } from "expo-font";

export default function useAppFonts() {
  const [fontIsReady] = useFonts({
    thinFA: require("../assets/fonts/IRANYekanMobile-Thin-FA.ttf"),
    lightFA: require("../assets/fonts/IRANYekanMobile-Light-FA.ttf"),
    regularFA: require("../assets/fonts/IRANYekanMobile-Regular-FA.ttf"),
    mediumFA: require("../assets/fonts/IRANYekanMobile-Medium-FA.ttf"),
    boldFA: require("../assets/fonts/IRANYekanMobile-Bold-FA.ttf"),
    extraBoldFA: require("../assets/fonts/IRANYekanMobile-ExtraBold-FA.ttf"),
    blackFA: require("../assets/fonts/IRANYekanMobile-Black-FA.ttf"),
    extraBlackFA: require("../assets/fonts/IRANYekanMobile-ExtraBlack-FA.ttf"),
    thinEN: require("../assets/fonts/IRANYekanMobile-Thin-EN.ttf"),
    lightEN: require("../assets/fonts/IRANYekanMobile-Light-EN.ttf"),
    regularEN: require("../assets/fonts/IRANYekanMobile-Regular-EN.ttf"),
    mediumEN: require("../assets/fonts/IRANYekanMobile-Medium-EN.ttf"),
    boldEN: require("../assets/fonts/IRANYekanMobile-Bold-EN.ttf"),
    extraBoldEN: require("../assets/fonts/IRANYekanMobile-ExtraBold-EN.ttf"),
    blackEN: require("../assets/fonts/IRANYekanMobile-Black-EN.ttf"),
    extraBlackEN: require("../assets/fonts/IRANYekanMobile-ExtraBlack-EN.ttf"),
  });

  return { fontIsReady };
}
